import React, { useEffect, useState } from "react";
import "./patient_list.scss";
import Sidebar from "../../components/Sidebar/Sidebar";
import Navbar from "../../components/Navbar/Navbar";
import Datatable from "../../components/Datatable/Datatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faHouseMedical,
  faPeopleGroup,
  faPerson,
  faPersonDress,
  faPhone,
  faStethoscope,
} from "@fortawesome/free-solid-svg-icons";
import Balancer from "react-wrap-balancer";
import TransitionModal from "../../components/Modal/Modal";
import Swal from "sweetalert2";
import { useChangePatientActiveStatusInListMutation, useChangePatientActiveStatusMutation, usePatientListQuery } from "../../redux/reducers/patient/patientApiSlice";
import { useNavigate } from "react-router-dom";

const PatientList = () => {
  let [pList, setPList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");

  const {
    data, 
    isLoading : listLoading,
    isSuccess : listSuccess,
    isError: listError,
    error,
    refetch,
    isFetching
  } = usePatientListQuery('patientList',{refetchOnMountOrArgChange: true});
  const [changePatientActiveStatusInList, {isLoading : statusLoading, isSuccess : statusSuccess, isError} ] = useChangePatientActiveStatusInListMutation();

  const openDoctorDetails = ({doctor_name,doctor_specialization,hospital_name,doctor_mob_no}) => {
    let detailsTitle = (
      <div className="modalTitleList">
        <FontAwesomeIcon icon={faStethoscope} className="icon" />
        <span>{`${doctor_name}'s Details`}</span>
      </div>
    )
    setModalTitle(detailsTitle);
    let detailsList = (
      <div className="modalBodyList">
        <ul>
          <li>
            <label>Doctor Name: </label>
            <span>{doctor_name}</span>
          </li>
          <li>
            <label>Specialization: </label>
            <span>{doctor_specialization}</span>
          </li>
          <li>
            <label>Hospital Name: </label>
            <span>{hospital_name}</span>
          </li>
          <li>
            <label>Doctor Phone No: </label>
            <span>{doctor_mob_no}</span>
          </li>
        </ul>
      </div>
    )
    setModalBody(detailsList);
    setOpenModal(true)
  }


  const listCols = [
    { field: "patient_id", headerName: "ID", width: 20, key:"id" },
    {
      field: "name",
      headerName: "Personal Details",
      width: 180,
      renderCell: (params) => {
        return (
          <div className="cellWithIconAndList" key={params.row.id}>
            <ul>
              <li>
                <strong>{params.row.patient_name}</strong>
              </li>
              <li>
                <FontAwesomeIcon icon={params.row.gender && params.row.gender.toLowerCase() === 'male' ? faPerson : faPersonDress} className="icon" />
                <i>{params.row.gender}</i>
              </li>
            </ul>
          </div>
        );
      },
    },
    {
      field: "contact_detail",
      headerName: "Contact Details",
      width: 250,
      renderCell: (params) => {
        return (
          <div className="cellWithIconAndList" key={params.row.id}>
            <ul>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="icon" />
                <span>{params.row.email}</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="icon" />
                <span>{params.row.mob_num}</span>
              </li>
            </ul>
          </div>
        );
      },
    },
    {
      field: "doctor_detail",
      headerName: "Doctor Details",
      width: 170,
      renderCell: (params) => {
        return (
          <div className="cellWithIconAndList" key={params.row.id}>
            <ul>
              <li>
                <a
                  href="javascript:void(0)"
                  style={{ cursor: "pointer" }}
                  onClick={()=> openDoctorDetails({...params.row})}
                >
                  {params.row.doctor_name}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faStethoscope} className="icon" />
                <span>{params.row.doctor_specialization}</span>
              </li>
            </ul>
          </div>
        );
      },
    },
    {
      field: "patient_status",
      headerName: "Status",
      width: 70,
      renderCell: (params) => {
        return (
          <div className="statusList" key={params.row.id}>
            <ul>
              <li>
                <div
                  className={`cellWithStatus ${
                    params.row.is_active === "Yes" ? "active" : "deactivate"
                  }`}
                >
                  <strong>
                    {params.row.is_active === "Yes" ? "Active" : "Deactive"}
                  </strong>
                </div>
              </li>
            </ul>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    if(listSuccess || statusSuccess || !isFetching){
      loadList();
    }
  }, [listSuccess,statusSuccess,!isFetching]);

  const loadList = async () => {
    try {
      let list = data.ids.map((v,i)=>{
        return data.entities[v]
      });
      setPList(list);
    }catch (e) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Something Went Wrong",
        text: e.message,
        showConfirmButton: true,
      });
    }
  };

  const navigate = useNavigate();
  const handlePatientStatus = async ({patientId, op}) => {
    try{
      const status = await changePatientActiveStatusInList({ patientId, op }).unwrap();
      refetch();
      if(status.status && status.status_code === 200){
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Status Changed Successfully",
          text: status.msg,
          timer: 5000,
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Something Went Wrong",
          text: status.msg,
          timer: 5000,
        })
      }
    }
    catch(e){
      console.log('Error ',e);
    }
  }

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        {(listSuccess || statusSuccess || !isFetching) && <Datatable
          listSource={"patientList"}
          listCols={listCols}
          listRows={listSuccess || statusSuccess ? pList : []}
          isLoading={listLoading}
          actionColWidth={350}
          handleStatus={handlePatientStatus}
        />}
        <TransitionModal
          modalOpen={openModal}
          handleClose={() => setOpenModal(false)}
          title={modalTitle}
          body={modalBody}
        />
      </div>
    </div>
  );
};

export default PatientList;
